import { render, staticRenderFns } from "./ResourcePosts.vue?vue&type=template&id=9f930770&"
import script from "./ResourcePosts.vue?vue&type=script&lang=js&"
export * from "./ResourcePosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports